import React, { useContext, useState } from 'react'
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { Box, Button, Container, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { FiscalYearListType, useInit } from '../DataFetch/useInit';
import { PreRegistrationType, usePreRegistration } from '../DataFetch/usePreRegistration';
import { GetPreRegistrationCSV } from '../DataFetch/ManagementAPI';
import { SessionContext } from '../ManagementRoot';
import { SaveCSVWithBOM } from '../Utility/SaveCSVWithBOM';
import { useErrorDialog } from '../Component/useErrorDialog';

export function PreRegistration() {

    const ConfirmSession = useContext(SessionContext)

    const {init} = useInit();

    const [currentYear, setCurrentYear] = useState(init?.fiscalyear);

    const {preRegistration, isLoading} = usePreRegistration(currentYear);

    const {openErrorDialog, ErrorDialog} = useErrorDialog();

    async function DownloadCSV() {

        if(!await ConfirmSession()) {
            return;
        }

        GetPreRegistrationCSV(currentYear)
        .then(res => {
            res !== undefined ? SaveCSVWithBOM(`${currentYear}_事前登録.csv`, res) : openErrorDialog();
        })
    }

    function PreRegistrationList() {
        return(
            <>
                <TableContainer sx={{maxHeight:500}}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell>エントリーID</TableCell>
                                <TableCell>国名</TableCell>
                                <TableCell>教育機関所属国名</TableCell>
                                <TableCell>氏名</TableCell>
                                <TableCell>生年月日</TableCell>
                                <TableCell>教育機関名</TableCell>
                                <TableCell>メールアドレス</TableCell>
                                <TableCell>グループ</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {preRegistration?.map((item:PreRegistrationType, index:number) => (
                                <TableRow key={index} hover>
                                    <TableCell>{item.artwork_id}</TableCell>
                                    <TableCell>{item.country_name}</TableCell>
                                    <TableCell>{item.educational_institution_country_name}</TableCell>
                                    <TableCell>{item.poster}</TableCell>
                                    <TableCell>{item.birthday}</TableCell>
                                    <TableCell>{item.educational_institution}</TableCell>
                                    <TableCell>{item.mailaddress}</TableCell>
                                    <TableCell>{item.group_flg}</TableCell>
                                </TableRow>
                            ))} 
                        </TableBody>
                    </Table>
                </TableContainer>
            </>
        );
    }

    return(
        <>
            <Typography
                variant="h6"
            >
                事前登録
            </Typography>
            
            <Grid2 xs={12}>
                <Paper>
                    <Container maxWidth="sm">
                        <Box p={2}>                         
                            <Typography
                                variant="body1"
                                p={1}
                            >
                                対象年度
                            </Typography>
                            <Select
                                defaultValue={init?.fiscalyear.toString()}
                                onChange={e => e.target.value !== currentYear ? setCurrentYear(e.target.value) : ""}
                                value={currentYear}
                            >
                                {
                                    init?.fiscal_year_list.map((value:FiscalYearListType, index:number) =>(
                                        <MenuItem key={index} value={value.target_year.toString()}>
                                            {value.target_year}
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                            <Box p={2}>
                                <Button variant="contained" onClick={DownloadCSV}>
                                    ダウンロード
                                </Button>
                            </Box>                    
                        </Box>
                    </Container>
                </Paper>
            </Grid2>
            <Grid2 xs={12}>
                <Paper sx={{overflow:"hidden", whiteSpace:"nowrap"}}>
                    {!isLoading && PreRegistrationList()}
                </Paper>
            </Grid2>

            <ErrorDialog/>
        </>
    );
}